export const ApiErrorMessages: Record<string, string> = {
  'Name must be unique.': 'This name already exists. Please choose another name.',
  'Code must be unique.': 'This code already exists. Please choose another code.',
  'TaxID must be unique.': 'This EIN already exists. Please choose another EIN.',
  'Name must be unique. | Code must be unique.':
    'This name already exists. Please choose another name.',
  'Name must be unique. | TaxID must be unique.':
    'This Name and EIN already exists. Please choose another Name and EIN.',
  'Name must be unique. | Code must be unique. | TaxID must be unique.':
    'This Name and EIN already exists. Please choose another Name and EIN.',
  'A person with same Email already exists.':
    'This Email already exists. Please choose another Email.',
  'A Company with same Email already exists.':
    'This Email already exists. Please choose another Email.',
  'Phone number must be exactly 10 digits and cannot start with 0.':
    'Phone number must be exactly 10 digits.',
  'Phone Number must be unique.':
    'Phone Number already exists. Please choose another Phone Number .',
};
